import React from 'react'
import './investmentheader.css'
import { Row, Container } from 'react-bootstrap';

const Investmentheader = ({selectedLanguage}) => {
    return (
        <>
            <section>
                <Container fluid className='investmentheader-section'>
                    <Row>
                        {selectedLanguage === "en" ? (
                        <h1 className='investment-heading'>Investing for sustainable <br /><span className='fw-bold'>financial growth</span></h1>
                        ) : (
                            <h1 className='investment-heading'>الاستثمار بهدف استدامة النمو المالي</h1>
                            )}
                    </Row>
                </Container>
                
            </section>
        </>
    )
}

export default Investmentheader